import { render } from "./ListarMatriculas.vue?vue&type=template&id=461a2f8b&scoped=true"
import script from "./ListarMatriculas.vue?vue&type=script&lang=js"
export * from "./ListarMatriculas.vue?vue&type=script&lang=js"

import "./ListarMatriculas.vue?vue&type=style&index=0&id=461a2f8b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461a2f8b"]])

export default __exports__